import React from "react";

import { PrimitiveNode, isPrimitive } from "./primitive";
import s from "./node.module.scss";
import { MapNode } from "./map/map";

interface Props {
    name: string;
    node: any;
}

const ObjectNode: React.FC<Props> = (props) => {
    const items = Object.keys(props.node).map((key) => ({
        name: key,
        node: props.node[key],
    }));
    return <MapNode {...props} items={items} />;
};

const ArrayNode: React.FC<Props> = (props) => {
    if (!Array.isArray(props.node)) throw Error("nodes must be an array");
    const items = props.node.map((node, index) => ({
        parentName: props.name,
        name: index.toString(),
        node,
    }));
    return <MapNode {...props} items={items} />;
};

const NodeBody: React.FC<Props> = (props) => {
    if (isPrimitive(props.node)) return <PrimitiveNode {...props} />;
    if (Array.isArray(props.node)) return <ArrayNode {...props} />;
    return <ObjectNode {...props} />;
};

export const Node: React.FC<Props> = (props) => (
    <div className={s.container}>
        <NodeBody {...props} />
    </div>
);
